<div class="modal-overlay" *ngIf="isOpen" (click)="onClose()">
  <div class="modal-dialog modal-lg modal-dialog-centered" (click)="$event.stopPropagation()">
    <div class="modal-content shadow-lg border-0">
      
      <div class="modal-header bg-light">
        <h5 class="modal-title d-flex align-items-center">
          <i class="bi bi-person-badge me-2"></i> Selecionar Cliente
        </h5>
        <button type="button" class="btn-close" (click)="onClose()" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <div class="input-group mb-4 shadow-sm">
          <span class="input-group-text bg-white border-end-0">
            <i class="bi bi-search text-muted"></i>
          </span>
          <input type="text" class="form-control border-start-0" 
                 placeholder="Pesquise por Nome, CPF, CNPJ ou Nome Fantasia..." 
                 [(ngModel)]="termo"
                 (keyup.enter)="search()"
                 #searchInput>
          <button class="btn btn-primary px-4" type="button" (click)="search()">Pesquisar</button>
        </div>

        <div class="table-responsive" style="max-height: 400px; overflow-y: auto;">
          <table class="table table-hover align-middle">
            <thead class="table-light sticky-top">
              <tr>
                <th class="text-center" style="width: 50px;">#</th>
                <th>Nome / Razão Social</th>
                <th style="width: 160px;">CPF / CNPJ</th>
                <th>Nome Fantasia</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let cliente of clientePage?.content" 
                  (click)="selectCliente(cliente)"
                  [class.table-primary]="selectedCliente.id === cliente.id"
                  style="cursor: pointer;">
                <td class="text-center">
                  <div class="form-check d-flex justify-content-center">
                    <input class="form-check-input" type="radio" name="cliente" 
                           [checked]="selectedCliente.id === cliente.id">
                  </div>
                </td>
                <td>
                  <div class="fw-bold text-dark">{{ cliente.nomeRazaoSocial }}</div>
                </td>
                <td>
                  <code class="text-muted" style="font-size: 0.9rem;">{{ cliente.cpfCnpj }}</code>
                </td>
                <td>
                  <span class="text-secondary small">{{ cliente.nomeFantasia || '-' }}</span>
                </td>
              </tr>

              <tr *ngIf="clientePage?.content?.length === 0">
                <td colspan="4" class="text-center py-5">
                  <i class="bi bi-person-exclamation fs-2 text-muted d-block mb-2"></i>
                  <span class="text-muted">Nenhum cliente encontrado.</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-3" *ngIf="clientePage && clientePage.totalPages > 1">
          <small class="text-muted">Mostrando página {{ page + 1 }} de {{ clientePage.totalPages }}</small>
          <nav>
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" [class.disabled]="page === 0">
                <button class="page-link" (click)="setPage(0)">Primeira</button>
              </li>
              <li class="page-item" [class.disabled]="page === 0">
                <button class="page-link" (click)="setPage(page - 1)">Anterior</button>
              </li>
              <li class="page-item" [class.disabled]="page >= clientePage.totalPages - 1">
                <button class="page-link" (click)="setPage(page + 1)">Próxima</button>
              </li>
              <li class="page-item" [class.disabled]="page >= clientePage.totalPages - 1">
                <button class="page-link" (click)="setPage(clientePage.totalPages - 1)">Última</button>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <div class="modal-footer bg-light">
        <button type="button" class="btn btn-outline-secondary" (click)="onClose()">Cancelar</button>
        <button class="btn btn-success px-5" type="button" 
                [disabled]="!selectedCliente" 
                (click)="inserirCliente()">
          <i class="bi bi-check-lg me-2"></i> Confirmar Seleção
        </button>
      </div>

    </div>
  </div>
</div>